export default __webpack_public_path__ + "static/media/facts_icon.03e8d49b.svg";